/* eslint semi:0 */
import BaseVm from './BaseVm'
import { getIsDesktop, getIsTablet } from '../../utils/ua'
import { socialComponentScrollerReached, titleScrollerReached } from '../actions/navbarActions'
import { getSingleElementByClass } from '../../utils/dom'
import socialButtonsConf from '../config/socialButtonsConfig'
import scrollingEventsProvider from '../../providers/scrollingEventsProvider'
import { wrapButtonInLabel } from '../views/ButtonView'

let scrollingEvents = [
  {
    element: getSingleElementByClass('share-component'),
    triggerPosition: {
      bottom: 0, // height percentage from top
      // bottom: 100, // height percentage from bottom
    },
    event: 'coverSharedIconsReached',
    relativeTopElement: getSingleElementByClass('header-container'),
  },
  {
    element: getSingleElementByClass('post-article__post-title'),
    triggerPosition: {
      bottom: 0, // height percentage from top
      // bottom: 100, // height percentage from bottom
    },
    event: 'postTitleReached',
    relativeTopElement: getSingleElementByClass('header-container'),
  },
]

export default class NavbarVm extends BaseVm {
  onChange(payload) {
    if (payload && payload.topHeight) {
      this.mobileHeaderTop = payload.topHeight
    }
    super.onChange(payload)
  }

  get mobileHeaderTop() {
    return this.state.mobileHeaderTop || 0
  }
  set mobileHeaderTop(topHeight) {
    this.state.mobileHeaderTop = topHeight
  }
  get mobileHeaderRepositioned() {
    return this.state.mobileHeaderRepositioned
  }
  set mobileHeaderRepositioned(bool) {
    this.state.mobileHeaderRepositioned = bool
  }

  coverSharedIconsReached(scrollingEventObject) {
    socialComponentScrollerReached(scrollingEventObject)
  }

  postTitleReached(scrollingEventObject) {
    titleScrollerReached(scrollingEventObject)
  }

  registerScrollingActions() {
    let vm = this
    scrollingEvents.forEach(function(eventConfig) {
      eventConfig.vm = vm
      scrollingEventsProvider.register(eventConfig)
    })
    return this
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/NavbarVM.js